module.exports = __webpack_public_path__ + "img/id-number-2.8ba60436.svg";